// Single source of truth for how a listing status is labelled and coloured,
// so the filter dropdown, the table badge and the details dialog always agree.
//
//   pending  🟡 warning   approved/active 🟢 success
//   rejected 🔴 error     sold            🔘 secondary
//   removed  ⚫ dark
//
// Sold uses "secondary" rather than "info" because this theme's info (#42A146) is
// green and would be indistinguishable from approved.

export const LISTING_STATUS_META = {
  pending: { label: "Pending Review", color: "warning", icon: "hourglass_empty" },
  approved: { label: "Approved", color: "success", icon: "check_circle" },
  active: { label: "Active", color: "success", icon: "check_circle" },
  rejected: { label: "Rejected", color: "error", icon: "cancel" },
  sold: { label: "Sold", color: "secondary", icon: "sell" },
  removed: { label: "Removed", color: "dark", icon: "delete_outline" },
};

const FALLBACK_META = { label: "Unknown", color: "secondary", icon: "help_outline" };

export const getListingStatusMeta = (status) => {
  if (!status) return FALLBACK_META;
  const meta = LISTING_STATUS_META[String(status).toLowerCase()];
  return meta || { ...FALLBACK_META, label: String(status) };
};

// Options for the status filter. "approved" and "active" share a colour but are
// distinct server-side values, so both stay selectable.
export const LISTING_STATUS_FILTER_OPTIONS = [
  { value: "", label: "All", icon: "list_alt" },
  ...["pending", "approved", "rejected", "sold", "removed"].map((value) => ({
    value,
    ...LISTING_STATUS_META[value],
  })),
];
